import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function pickList(res) {
  const d = res?.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  return [];
}

function* fetchAvailable() {
  try {
    yield put(actions.setStudentOfficeHoursLoading(true));
    const result = yield call(api.getOfficeHoursForStudent);
    const list = pickList(result);
    yield put(actions.getStudentOfficeHoursSuccess(list));
  } catch (e) {
    yield put(actions.getStudentOfficeHoursFail());
    toast.error(e?.response?.data?.message || "Could not load office hours.");
  } finally {
    yield put(actions.setStudentOfficeHoursLoading(false));
  }
}

function* fetchUpcoming({ payload: studentId }) {
  if (studentId == null || studentId === "") return;
  try {
    yield put(actions.setUpcomingOfficeHoursLoading(true));
    const result = yield call(api.getUpcomingOfficeHoursForStudent, studentId);
    const list = pickList(result);
    yield put(actions.getUpcomingOfficeHoursSuccess(list));
  } catch (e) {
    yield put(actions.getUpcomingOfficeHoursFail());
    toast.error(e?.response?.data?.message || "Could not load upcoming sessions.");
  } finally {
    yield put(actions.setUpcomingOfficeHoursLoading(false));
  }
}

function* apply({ payload }) {
  const { studentId, officeHourId, onDone } = payload || {};
  if (studentId == null || officeHourId == null) return;
  try {
    yield put(actions.setApplyOfficeHourLoading(true));
    const result = yield call(api.applyForOfficeHour, studentId, officeHourId);
    yield put(actions.applyForOfficeHourSuccess(result?.data));
    toast.success(result?.data?.message || "Applied successfully.");
    onDone?.();
    yield put(actions.getStudentOfficeHoursRequest());
    yield put(actions.getUpcomingOfficeHoursRequest(studentId));
  } catch (e) {
    yield put(actions.applyForOfficeHourFail());
    const msg = e?.response?.data?.message || e?.message || "Could not apply.";
    toast.error(msg);
  } finally {
    yield put(actions.setApplyOfficeHourLoading(false));
  }
}

export default function* studentOfficeHoursSaga() {
  yield takeLatest(Types.GET_STUDENT_OFFICE_HOURS_REQUEST, fetchAvailable);
  yield takeLatest(Types.GET_UPCOMING_OFFICE_HOURS_REQUEST, fetchUpcoming);
  yield takeLatest(Types.APPLY_OFFICE_HOUR_REQUEST, apply);
}
